// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Ih8R","left":"InfoRow_left__3LW_d"};